import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: true,
};

const SidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.open = !state.open;
    },
  },
});

export const { toggleSidebar } = SidebarSlice.actions;

export default SidebarSlice;
